import { Inject, Injectable, Injector }from '@angular/core';


import { SPSCommerce_ds_find_order_and_shipment_by_transaction_idService } from './SPSCommerce.datasource.index';
import { SPSCommerce_ds_get_cancelled_shipments_without_transmissionsService } from './SPSCommerce.datasource.index';

@Injectable({ providedIn: 'root' })
export class SPSCommerce_DatasourceService {

  constructor(
    private injector: Injector
  ) {
  }

  public SPSCommerce: SPSCommerce_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _ds_find_order_and_shipment_by_transaction_id: SPSCommerce_ds_find_order_and_shipment_by_transaction_idService;
  public get ds_find_order_and_shipment_by_transaction_id(): SPSCommerce_ds_find_order_and_shipment_by_transaction_idService {
    if(!this._ds_find_order_and_shipment_by_transaction_id) {
      this._ds_find_order_and_shipment_by_transaction_id = this.injector.get(SPSCommerce_ds_find_order_and_shipment_by_transaction_idService);
    }
    return this._ds_find_order_and_shipment_by_transaction_id;
  }
  private _ds_get_cancelled_shipments_without_transmissions: SPSCommerce_ds_get_cancelled_shipments_without_transmissionsService;
  public get ds_get_cancelled_shipments_without_transmissions(): SPSCommerce_ds_get_cancelled_shipments_without_transmissionsService {
    if(!this._ds_get_cancelled_shipments_without_transmissions) {
      this._ds_get_cancelled_shipments_without_transmissions = this.injector.get(SPSCommerce_ds_get_cancelled_shipments_without_transmissionsService);
    }
    return this._ds_get_cancelled_shipments_without_transmissions;
  }
}

